export default __webpack_public_path__ + "static/media/list-text.66d4713c.svg";